import { AxiosPromise } from "axios";
import customAxios from "./api/customAxios";
import {
  getAccessToken,
  getOrganization,
  getTokenType
} from "./route/LocalStorage";

export class RequestWrapper {
  public static to(url: string): RequestWrapper {
    return new RequestWrapper(url);
  }

  private readonly url: string;
  private body: any;
  private params: any = {};
  private options: any = {};
  private creditLensSpreadId: string = "";

  private hasAuth: boolean = false;
  private hasJSON: boolean = false;
  private authType: boolean = false;
  private hasPost: boolean = false;
  private hasDelete: boolean = false;
  private isCreditLens: boolean = false;
  private ssoHeaderContent: string = "";

  constructor(url: string) {
    this.url = url;
  }

  public withAuth(): RequestWrapper {
    this.hasAuth = true;
    return this;
  }

  public asJSON(): RequestWrapper {
    this.hasJSON = true;
    return this;
  }

  public setAuthType(): RequestWrapper {
    this.authType = true;
    return this;
  }

  public asPost(body: any): RequestWrapper {
    this.hasPost = true;
    this.body = body;
    return this;
  }

  public asDelete(): RequestWrapper {
    this.hasDelete = true;
    return this;
  }

  public withParams(params: object): RequestWrapper {
    this.params = params;
    return this;
  }

  public withOptions(options: object): RequestWrapper {
    this.options = options;
    return this;
  }

  public withCreditLensSpreadIdInHeader(spreadId: string): RequestWrapper {
    this.isCreditLens = true;
    this.creditLensSpreadId = spreadId;
    return this;
  }

  public withSSOHeaderContent(credentials): RequestWrapper {
    this.ssoHeaderContent = credentials;
    return this;
  }

  public request<T = any>(): AxiosPromise<T> {
    const headers: any = {};
    const params = this.params;
    const options = this.options;

    if (this.hasAuth) {
      headers.accessToken = getAccessToken();
    }

    if (this.hasJSON) {
      headers["Content-Type"] = "application/json";
    }

    if (this.authType) {
      if (getTokenType() === "jwt") {
        headers.authType = "sso";
        headers.organization = getOrganization();
      } else {
        headers.authType = "native";
      }
    }

    if (this.isCreditLens) {
      headers.accessToken = this.creditLensSpreadId;
    }

    if (this.ssoHeaderContent) {
      headers.accept = "*/*";
      headers.Authorization = `Basic ${this.ssoHeaderContent}`;
      headers["Content-Type"] = "application/x-www-form-urlencoded";
    }

    if (this.hasDelete) {
      headers.Authorization = `Bearer ${getAccessToken()}`;
    }

    if (this.hasPost) {
      return customAxios.post<T>(this.url, this.body, {
        headers,
        params,
        ...options
      });
    }

    if (this.hasDelete) {
      return customAxios.delete(this.url, {
        headers,
        params,
        ...options
      });
    }

    return customAxios.get<T>(this.url, { headers, params, ...options });
  }
}



// WEBPACK FOOTER //
// ./src/requestWrapper.ts